import { useReduxActions } from 'hooks/useReduxActions';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isLoggedInSelector } from 'store/selectors';

const Fetch = () => {
  const actions = useReduxActions();
  const isLoggedIn = useSelector(isLoggedInSelector);

  useEffect(() => {
    if (localStorage.getItem('accessToken') && !isLoggedIn) {
      actions.setIsLoggedIn(true);
    }
    if (isLoggedIn) {
      actions.getCurrentUser();
    }
  }, [isLoggedIn]); // eslint-disable-line
  return null;
};

export default Fetch;
